var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',[_c('ms-badge',{attrs:{"value":"小标点"}},[_vm._v("我的学员")])],1),_c('div',[_c('ms-badge',{attrs:{"value":"hellow"}},[_vm._v("我的学员")])],1),_c('div',[_c('ms-badge',{attrs:{"value":100,"max":99}},[_vm._v("我的学员")])],1),_c('div',[_c('ms-badge',{attrs:{"value":1,"max":99}},[_vm._v("我的学员")])],1),_c('div',[_c('ms-badge',{attrs:{"is-dot":""}},[_vm._v("我的学员")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-306a38ba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/badge.vue
// module id = null
// module chunks = 